export interface UnitV2 {
  unitId: number;
  unitCode: string;
  unitDesc: string;
  unitType: {
    unitTypeId: number;
    unitTypeCode: string;
  };
}
